import EditUser from './edit-user-container';

export default EditUser;
